<template>
    <div class="addressModal">
        <el-dialog :title="title" :visible="isShow" width="50%" @close="close" :center="true">
            <el-form ref="form" :model="addressFormObj" :rules="rules" label-width="100px" class="demo-ruleForm"  v-loading="isLoadingModal">
               <!-- <el-form-item label="userId">
                   测试: -{{userId}};   type:-{{type}};  id:-{{editId}}
                </el-form-item> -->
                <el-form-item label="联系人" required prop="addressContactName">
                    <el-input v-model="addressFormObj.addressContactName"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" required prop="addressContactPhone">
                    <el-input v-model="addressFormObj.addressContactPhone"></el-input>
                </el-form-item>
                <el-form-item label="所在地区">
                    <el-select v-model="addressFormObj.regionProvinceId" placeholder="省份" @change="getAddressOption(addressFormObj.regionProvinceId,'prov')">
                        <el-option :label="listP.region_name" :value="listP.region_id" v-for="(listP,index) in provOptions"></el-option>
                    </el-select>
                    <el-select v-model="addressFormObj.regionCityId" placeholder="市" @change="getAddressOption(addressFormObj.regionCityId,'city')">
                        <el-option :label="listC.region_name" :value="listC.region_id" v-for="(listC,index) in cityOptions"></el-option>
                    </el-select>
                    <el-select v-model="addressFormObj.regionDistrictId" placeholder="县/区" @change="getAddressOption(addressFormObj.regionDistrictId,'dist')">
                        <el-option :label="listD.region_name" :value="listD.region_id" v-for="(listD,index) in distOptions"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详细地址" required prop="addressString">
                    <el-input v-model="addressFormObj.addressString"></el-input>
                </el-form-item>
                <el-form-item label="是否默认">
                    <el-radio-group v-model="addressFormObj.addressIsDefault">
                        <el-radio label="y">是</el-radio>
                        <el-radio label="n">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit('form')">立即创建</el-button>
                    <el-button @click="close">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        utils
    } from '@/common/common.js'
    import {
        ajaxPost
    } from '@/common/request.js'
    import {
        ajaxApp,
        api_app
    } from '@/common/request_app.js'
    export default {
        name: 'authmodal',
        data() {
            return {
                isLoadingModal:false,
                provOptions: [],
                cityOptions: [],
                distOptions: [],
                rules: {},
                addressFormObj: {
                    addressContactName: '',
                    addressContactPhone: '',
                    addressString: '',
                    addressIsDefault: 'n',
                    regionProvinceId: '',
                    regionCityId: '',
                    regionDistrictId: '',
                    regionProvinceString: '',
                    regionCityString: '',
                    regionDistrictString: '',
                },
            }
        },
        props: ['isShow', 'userId', 'type', 'editId'],
        components: {},
        computed: {
            title() {
                if (this.type == 'add') {
                    return "添加地址"
                }
                if (this.type == 'edit') {
                    return "编辑地址"
                }
            }
        },
        methods: {
            close() {
                console.log("emit close")
                this.$emit('closeModal');
            },
            submitSuccessFun(){
                console.log("submitSuccessFun触发")
                this.$emit('submitSuccessFun');
            },
            getAddressOption(id, type) {
                let _this = this
                let arg = {
                    parentId: id
                }
                ajaxApp('/globalRegionInfo/regionInfo', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        if (id == 0) {
                            //初始化
                            _this.provOptions = res.data
                            _this.cityOptions = []
                            _this.distOptions = []
                        } else if (type == 'prov') {
                            _this.cityOptions = res.data
                            _this.addressFormObj.regionCityId = ''
                            _this.addressFormObj.regionDistrictId = ''
                        } else if (type == 'city') {
                            _this.distOptions = res.data
                            _this.addressFormObj.regionDistrictId = ''
                        }
                    }
                }, function(res) {})
            },
            getAddressStrFromId(id, arr) {
                let result = ''
                arr.forEach(function(item, index) {
                    if (item.region_id == id) {
                        result = item.region_name
                        return false
                    }
                })
                return result
            },
            initAddressModal(){
                let _this = this
                _this.addressFormObj={
                    addressContactName:'',
                    addressContactPhone:'',
                    addressString:'',
                    addressIsDefault: 'n',
                    regionProvinceId:'',
                    regionCityId:'',
                    regionDistrictId:'',
                    regionProvinceString:'',
                    regionCityString:'',
                    regionDistrictString: '',
                }
            },
            getDetailById(id) {
                let _this = this
                console.log("开始获取地址详情")
                _this.isLoadingModal=true
                let arg = {
                    addressId: id
                }
                ajaxApp('/yijiajiaUserAddress/findUserAddressByAId', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.getAddressOption( res.data.region_province_id, 'prov')
                        _this.getAddressOption(res.data.region_city_id, 'city')
                        setTimeout(function(){
                             _this.isLoadingModal=false
                            _this.addressFormObj={
                                addressContactName: res.data.address_contact_name,
                                addressContactPhone: res.data.address_contact_phone,
                                addressString: res.data.address_string,
                                addressIsDefault: res.data.address_is_default,
                                regionProvinceId: res.data.region_province_id,
                                regionCityId:res.data.region_city_id,
                                regionDistrictId:res.data.region_district_id,
                                regionProvinceString: res.data.region_province_string,
                                regionCityString: res.data.region_city_string,
                                regionDistrictString: res.data.region_district_string
                            }
                        },500)
                        
                    } else {
                        _this.$message({
                            message: res.errorMsg,
                            type: 'error',
                            duration: 1000
                        });
                    }
                }, function(res) {
                    
                })
            },
            onSubmit(formName) {
                let _this = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        alert("验证通过")
                        if (this.type == 'add') { //添加接口
                            let argAdd = {
                                addressContactName: _this.addressFormObj.addressContactName,
                                addressContactPhone: _this.addressFormObj.addressContactPhone,
                                addressIsDefault: _this.addressFormObj.addressIsDefault,
                                addressString: _this.addressFormObj.addressString,
                                regionProvinceId: _this.addressFormObj.regionProvinceId,
                                regionProvinceString: _this.getAddressStrFromId(_this.addressFormObj.regionProvinceId,
                                    _this.provOptions),
                                regionCityId: _this.addressFormObj.regionCityId,
                                regionCityString: _this.getAddressStrFromId(_this.addressFormObj.regionCityId,
                                    _this.cityOptions),
                                regionDistrictId: _this.addressFormObj.regionDistrictId,
                                regionDistrictString: _this.getAddressStrFromId(_this.addressFormObj.regionDistrictId,
                                    _this.distOptions),
                                userId: _this.userId,
                            }
                            ajaxApp('/yijiajiaUserAddress/addUserAddress', argAdd).then(function(res) {
                                if (res.errorCode == 200) {
                                    _this.$message({
                                        message: res.errorMsg,
                                        type: 'success',
                                        duration: 1000
                                    });
                                    _this.close()
                                    _this.submitSuccessFun()
                                } else {
                                    _this.$message({
                                        message: res.errorMsg,
                                        type: 'error',
                                        duration: 1000
                                    });
                                }
                            }, function(res) {})
                        }
                        if (this.type == 'edit') { //编辑接口
                            let argEdit = {
                                addressContactName: _this.addressFormObj.addressContactName,
                                addressContactPhone: _this.addressFormObj.addressContactPhone,
                                addressIsDefault: _this.addressFormObj.addressIsDefault,
                                addressString: _this.addressFormObj.addressString,
                                regionProvinceId: _this.addressFormObj.regionProvinceId,
                                regionProvinceString: _this.getAddressStrFromId(_this.addressFormObj.regionProvinceId,
                                    _this.provOptions),
                                regionCityId: _this.addressFormObj.regionCityId,
                                regionCityString: _this.getAddressStrFromId(_this.addressFormObj.regionCityId,
                                    _this.cityOptions),
                                regionDistrictId: _this.addressFormObj.regionDistrictId,
                                regionDistrictString: _this.getAddressStrFromId(_this.addressFormObj.regionDistrictId,
                                    _this.distOptions),
                                userId: _this.userId,
                                addressId: _this.editId
                            }
                            ajaxApp('/yijiajiaUserAddress/updateAddressByAddressId', argEdit).then(function(res) {
                                if (res.errorCode == 200) {
                                    _this.$message({
                                        message: res.errorMsg,
                                        type: 'success',
                                        duration: 1000
                                    });
                                    _this.close()
                                    _this.submitSuccessFun()
                                } else {
                                    _this.$message({
                                        message: res.errorMsg,
                                        type: 'error',
                                        duration: 1000
                                    });
                                }
                            }, function(res) {})
                        }

                    }
                })
            }
        },
        mounted() {
           this.getAddressOption(0)
        }
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/addAddressModal.vue